<template>
    <component
        :is="component"
        class="FooterTitle mb-3.5 block text-smaller font-medium uppercase leading-none text-black dark:text-txt-body"
        v-bind="$attrs"
    >
        <slot />
    </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
    to?: any
    href?: string
}>()

const isNuxtLink = computed(() => Boolean(props.to))
const isLink = computed(() => Boolean(props.href))

const component = computed(() => {
    if (isNuxtLink.value) {
        return resolveComponent('NuxtLink')
    }

    if (isLink.value) {
        return 'a'
    }

    return 'div'
})
</script>
